import Repository from './Repository'

export default {
  getTypesAnswerResponses (params) {
    return Repository.private().get(
      'claim/types-answer'
    )
  }
}
